module.exports = __webpack_public_path__ + "static/media/address-others-icon.376c56ea.svg";